import { Link } from "react-router-dom";
import { StatusBadge } from "@/components/ui/status-badge";
import type { VendorDetail } from "@/lib/api/acquisitions";

type VendorSummaryStripProps = {
  vendor: VendorDetail;
};

export function VendorSummaryStrip({ vendor }: VendorSummaryStripProps) {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-slate-200 bg-white px-4 py-4 sm:flex-row sm:items-start sm:justify-between sm:px-5">
      <div className="space-y-2">
        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge variant={vendor.isActive ? "success" : "neutral"}>
            {vendor.isActive ? "Active" : "Inactive"}
          </StatusBadge>
          <span className="font-mono text-sm text-slate-500">{vendor.code}</span>
        </div>
        {vendor.contactPerson ? (
          <p className="text-sm text-slate-700">
            Contact: <span className="font-medium text-slate-900">{vendor.contactPerson}</span>
          </p>
        ) : null}
      </div>

      <div className="flex flex-wrap gap-4 text-sm sm:justify-end">
        <Link
          to={`/acquisitions/orders?vendorId=${vendor.id}`}
          className="rounded-md border border-slate-200 px-3 py-2 hover:border-primary/30 hover:bg-slate-50 transition-colors"
        >
          <span className="block text-xs text-slate-500">Purchase orders</span>
          <span className="font-semibold tabular-nums text-slate-900">
            {vendor._count.purchaseOrders}
          </span>
        </Link>
        <Link
          to={`/acquisitions/invoices?vendorId=${vendor.id}`}
          className="rounded-md border border-slate-200 px-3 py-2 hover:border-primary/30 hover:bg-slate-50 transition-colors"
        >
          <span className="block text-xs text-slate-500">Invoices</span>
          <span className="font-semibold tabular-nums text-slate-900">
            {vendor._count.invoices}
          </span>
        </Link>
      </div>
    </div>
  );
}
